(() => {
    function initGlassix() {
        const glassixWidgetOptions = {
            "numbers": [
                {
                    "number": "972732248369",
                    "name": "עצמל׳ה",
                    "subtitle": ""
                }
            ],
            "left": false,
            "ltr": true,
            "popup": "WELCOME",
            "title": "ברוכים הבאים לעצמל׳ה",
            "subtitle": ""
        };

        (function (t) {
            var e = function () {
                if (typeof GlassixWhatsAppWidgetClient === "function") {
                    window.whatsAppWidgetClient = new GlassixWhatsAppWidgetClient(t);
                    whatsAppWidgetClient.attach();
                } else {
                    i();
                }
            },
                i = function () {
                    a.src = "https://cdn.glassix.com/clients/whatsapp.widget.1.2.min.js";
                    a.onload = e;
                    document.body.removeChild(s);
                    n.parentNode.insertBefore(a, n);
                },
                n = document.getElementsByTagName("script")[0],
                s = document.createElement("script"),
                a;

            s.async = true;
            s.type = "text/javascript";
            s.crossOrigin = "anonymous";
            s.id = "glassix-whatsapp-widget-script";
            a = s.cloneNode();
            s.onload = e;
            s.src = "https://cdn.glassix.com/clients/whatsapp.widget.1.2.min.js";

            if (!document.getElementById(s.id) && document.body) {
                n.parentNode.insertBefore(s, n);
                s.onerror = i;
            }

        })(glassixWidgetOptions);

    }

    // check if document is loaded and load accordingly
    if (document.readyState === 'loading')
        document.addEventListener('DOMContentLoaded', initGlassix);
    else
        initGlassix();
})()
